import module from './module.js'
/* Config */
import './config.js'
/* Run */
import './run.js'
/* Styles */
import './themes/day.scss'
import './themes/night.scss'

export default module.name



// WEBPACK FOOTER //
// ./src/app/index.js